import { clientOnly } from '@solidjs/start';
import { Ref } from '@solid-primitives/refs';
import './index.css';

export interface Props extends ParentProps {
  /** 自定义类名 */
  class?: string;
}

/**
 * 当 children 挂载时，子组件会 slide（滑动）并且 fade in（淡入）
 * 使用纯 CSS 实现，动画参数固定：垂直方向 20px，300ms，ease-out
 */
const AnimateFly = (props: Props) => {
  return (
    <Ref
      ref={(ele) => {
        if (!ele) return;
        ele.classList.add('animate-fly');
      }}
    >
      {props.children}
    </Ref>
  );
};

export default clientOnly(async () => ({ default: AnimateFly }), { lazy: true });
